import {
  useEffect,
  useRef,
  useState,
  type FC,
  type ReactNode,
  type RefObject,
} from "react";
import { twMerge } from "tailwind-merge";

export interface TranscriptScrollPaneProps {
  children: ReactNode;
  className?: string;
  scrollContainerRef?: RefObject<HTMLDivElement | null>;
}

/** Scrollable transcript content with a fade under the video or header. */
export const TranscriptScrollPane: FC<TranscriptScrollPaneProps> = (props) => {
  const { children, className, scrollContainerRef } = props;
  const ownRef = useRef<HTMLDivElement>(null);
  const ref = scrollContainerRef ?? ownRef;
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    setHasScrolled((ref.current?.scrollTop ?? 0) > 0);
  }, [ref]);

  return (
    <div className="relative min-h-0 flex-1">
      {hasScrolled ? (
        <div
          aria-hidden
          className="pointer-events-none absolute inset-x-0 top-0 z-10 h-4 bg-gradient-to-b from-white via-white/80 to-transparent"
        />
      ) : null}
      <div
        ref={ref}
        className={twMerge("h-full min-h-0 overflow-y-auto", className)}
        onScroll={(event) => setHasScrolled(event.currentTarget.scrollTop > 0)}
      >
        {children}
      </div>
    </div>
  );
};
